import { render, staticRenderFns } from "./addCustomGoods.vue?vue&type=template&id=3c9577f7&scoped=true&"
import script from "./addCustomGoods.vue?vue&type=script&lang=js&"
export * from "./addCustomGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9577f7",
  null
  
)

export default component.exports